import _DeleteAppointment from './DeleteAppointment.vue';
import _ModalSuccess from './Success.vue';

export const DeleteAppointment = _DeleteAppointment;
export const ModalSuccess = _ModalSuccess;

